import { render, staticRenderFns } from "./FormElementExplanatoryText.vue?vue&type=template&id=23d2740b&scoped=true&"
import script from "./FormElementExplanatoryText.vue?vue&type=script&lang=js&"
export * from "./FormElementExplanatoryText.vue?vue&type=script&lang=js&"
import style0 from "./FormElementExplanatoryText.vue?vue&type=style&index=0&id=23d2740b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d2740b",
  null
  
)

export default component.exports